import {
  composeViewWithDimensions,
  downloadBlob,
  exportFileName,
} from '../../utils/dimension/dimensionExport';
import { selectDimension } from '../../store/reducers/dimension.reducer';

/** Chờ `count` frame để lớp vẽ cập nhật xong (vd. sau khi bỏ chọn DIM). */
const nextFrames = (count = 2) =>
  new Promise(resolve => {
    const raf =
      typeof requestAnimationFrame === 'function'
        ? requestAnimationFrame
        : cb => setTimeout(cb, 16);
    const step = n => (n <= 0 ? resolve() : raf(() => step(n - 1)));
    step(count);
  });

/**
 * Xuất góc nhìn hiện tại (canvas 3D + lớp DIM) ra file ảnh và tải xuống.
 * Bỏ chọn DIM trước khi chụp để không dính nét nổi bật.
 *
 * @returns {Promise<string>} tên file đã tải
 */
export const exportCurrentView = async ({
  sceneManager,
  dispatch,
  format = 'image/png',
  scale = 2,
  includeDimensions = true,
}) => {
  const canvas = sceneManager?.renderer?.domElement;
  if (!canvas) throw new Error('Chưa có khung nhìn 3D để xuất ảnh');
  dispatch?.(selectDimension(null));
  await nextFrames(2);
  const blob = await composeViewWithDimensions({
    canvas,
    svg: document.getElementById('dimension-overlay'),
    scale,
    format,
    includeDimensions,
  });
  const filename = exportFileName(format);
  downloadBlob(blob, filename);
  return filename;
};
